import { html, svg } from 'lit';
const path = svg `<path d="M29.625 8.25H10.375C8.89844 8.25 7.75 9.45312 7.75 10.875V30.125C7.75 31.6016 8.89844 32.75 10.375 32.75H29.625C31.0469 32.75 32.25 31.6016 32.25 30.125V10.875C32.25 9.45312 31.0469 8.25 29.625 8.25Z"/>`;
export default html `<svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">${path}</svg>`;
//# sourceMappingURL=stop.js.map